import { Box, styled } from "@mui/material";
import React from "react";
import { Logo } from "@components";

const Image = styled(Box, {
  shouldForwardProp: (prop) => prop !== "hasImage",
})<{
  hasImage?: boolean;
  width?: number;
  height?: number;
}>(({ theme, hasImage, width, height }) => ({
  borderRadius: `${theme.shape.borderRadius}px`,
  width: width,
  height: height,
  border: `1px solid ${theme.palette.border.secondary}`,
  backgroundColor: hasImage
    ? theme.palette.common.white
    : theme.palette.background.neutralDark,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexShrink: 0,
  padding: hasImage ? 0 : theme.spacing(1.5),

  "& svg": {
    color: theme.palette.common.white,
  },

  "& img": {
    borderRadius: theme.shape.borderRadius,
    objectFit: "contain",
    width: "100%",
    height: "100%",
  },
}));

const Circle = styled(Box)<{ color?: string }>(({ theme, color }) => ({
  width: 11,
  height: 11,
  borderRadius: "50%",
  backgroundColor: color,
  position: "absolute",
  bottom: 0,
  left: 0,
  marginLeft: theme.spacing(7),
  marginBottom: theme.spacing(0.75),
  border: `2px solid ${theme.palette.background.default}`,
}));

type Props = {
  src?: string | null;
  alt?: string;
  width?: number;
  height?: number;
  circleColor?: string;
};

export const SecurityImage = ({
  src,
  alt,
  width = 40,
  height = 40,
  circleColor,
}: Props) => {
  return (
    <Image hasImage={Boolean(src)} width={width} height={height}>
      {src ? <img src={src || ""} alt={alt} /> : <Logo variant="asset" />}
      {circleColor && <Circle color={circleColor} />}
    </Image>
  );
};
